// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QBzb","footer":"styles_footer__4hQGb","passCodeTooltip":"styles_passCodeTooltip__3eeJo"};